<template>
  <div>
    <div id="captcha-button">
      <!-- 插槽文字 -->
      <slot></slot>
    </div>
    <div id="captcha-element"></div>
  </div>
</template>
<script>
import http from '../common/js/http';
import { Promise } from 'es6-promise';
import globalConfig from 'common/js/GlobalConfig';

export default {
  data () {
    // 这里存放数据
    return {
      captcha: null,
      captchaButton: null,
    }
  },
  props: ["handCallback", "verify", "targetId", "verifyType", "mobileOrEmail"],
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getInstance (instance) {
      this.captcha = instance;
    },
    /**
     * @verifyType 业务场景
     */
    async captchaVerifyCallback (captchaVerifyParam) {
      return new Promise((resolve, reject) => {
        if (this.verify) this.verify(async () => {
          // 1.向后端发起业务请求，获取验证码验证结果和业务结果
          const param = {
            captchaVerifyParam,// 验证码参数
            source: 1, // 1 web  2 h5
            targetId: '', // 手机号或者邮箱
            origin: 'ebq' // 参照account.ebaoquan.org/login/sendLoginCode 的origin 有则照着给没有就不管他
          }
          const { targetId, verifyType, mobileOrEmail } = this
          if (targetId) param.targetId = targetId
          if (mobileOrEmail) param.mobileOrEmail = mobileOrEmail
          let res = null
          switch (verifyType) {
            // 登录业务
            case 1:
              res = await this.loginNotic(param)
              break;
            // 注册业务
            case 2:
              res = await this.registerNotic(param)
              break;
            default:
              // res = await this.loginNotic(param)
              break;
          }
          // 2.构造标准返回参数
          if (!res.success) return { captchaResult: false }
          const {
            /** 验证码校验结果 */
            captchaVerifyResult,
            /** 短信发送结果 */
            sendVerifyCodeResult,
            /** 短信发送详情 */
            sendVerifyCodeInfo,
            /**短信发送失败信息 */
            sendVerifyCodeMsg,
            /** 短信发送失败错误码 */
            sendVerifyCodeResultCode
          } = res.data
          if (captchaVerifyResult && sendVerifyCodeResult) this.$message.success('短信发送成功')
          if (captchaVerifyResult && !sendVerifyCodeResult) this.$message.error(sendVerifyCodeMsg || '发送失败')
          resolve({
            captchaResult: captchaVerifyResult, // 验证码验证是否通过，boolean类型，必选
            bizResult: Boolean(sendVerifyCodeResult), // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
          });
        })
      })
    },
    // 验证通过后调用 (人话：原来该干嘛干嘛)
    onBizResultCallback (bizResult) {
      if (this.handCallback && bizResult) this.handCallback()
    },
    // 登录业务短信
    loginNotic (param) {
      return new Promise((resole, reject) => {
        // Promise start
        const url = `${globalConfig.domain.accountWeb}/validateCode/aliCaptchaToSendLoginCode`
        http.post(url, param, (response) => {
          // var res = response.data;
          resole(response.data)
        })
        // Promise end
      })
    },
    // 注册业务短信
    registerNotic (param) {
      return new Promise((resole, reject) => {
        // Promise start
        const url = `${globalConfig.domain.accountWeb}/validateCode/aliCaptchaToSendAuthCode/mobileRegister`
        http.post(url, param, (response) => {
          // var res = response.data;
          resole(response.data)
        })
        // Promise end
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () { },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.captchaButton = document.getElementById('captcha-button');
    window.initAliyunCaptcha({
      SceneId: '10lq13vq', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      prefix: 'lvkajq', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
      mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
      element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      button: '#captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
      captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
      onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
      getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
      slideStyle: {
        width: 360,
        height: 40,
      }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
      language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
    });
  },
  beforeDestroy () {
    this.captchaButton = null;
    // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
    let mask = document.getElementById('aliyunCaptcha-mask'), popup = document.getElementById('aliyunCaptcha-window-popup')
    if (mask) mask.remove()
    if (popup) popup.remove()
  }
}
</script>
<style lang='less' scoped>
// @import url(); 引入公共css类
</style>



// WEBPACK FOOTER //
// aliCaptcha.vue?aae78cfa